/* tslint:disable */
import { RoleResource } from "./RoleResource"
import { Role2Resource } from "./Role2Resource"

export class ExClientsResource {
		email: string;
		rid: number;
		companyName: string;
		phone: string;
		dateCreated: string;
		dateDeleted: string;
		bpo: boolean;
}
